import { useMemo } from 'react';
import { AddLiquidityParams, LiquidityAction } from '@/types';
import { useAnalyticsUserMetadata } from './useAnalyticsUserMetadata';
export const useAddLiquidityEventData = ({
  chainId,
  addLiquidityParams,
}: {
  chainId: number;
  addLiquidityParams: AddLiquidityParams;
}) => {
  const userMetadata = useAnalyticsUserMetadata();
  return useMemo(
    () => ({
      chainId,
      asset0Symbol: addLiquidityParams.asset0?.displaySymbol,
      asset1Symbol: addLiquidityParams.asset1?.displaySymbol,
      asset0Amount: Number(addLiquidityParams.asset0DepositAmountHumanReadable),
      asset1Amount: Number(addLiquidityParams.asset1DepositAmountHumanReadable),
      isNewPosition: addLiquidityParams.liquidityAction === LiquidityAction.MINT,
      tickLower: addLiquidityParams.tickLower,
      tickUpper: addLiquidityParams.tickUpper,
      positionId: addLiquidityParams.positionId?.toString(),
      ...userMetadata,
    }),
    [addLiquidityParams, chainId, userMetadata],
  );
};
